import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Assessment from "@/pages/Assessment";
import Report from "@/pages/Report";
import SharedReport from "@/pages/SharedReport";
import AccessLogin from "@/pages/AccessLogin";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Compare from "@/pages/Compare";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PartnerPage from "@/pages/PartnerPage";
import AssessmentsPage from "@/pages/AssessmentsPage";
import Mentors from "@/pages/Mentors";
import MentorProfile from "@/pages/MentorProfile";
import Checkout from "@/pages/Checkout";
import OrderStatus from "@/pages/OrderStatus";
import Contact from "@/pages/Contact";

function AppRouter() {
  const location = useLocation();
  // Process OAuth session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/assessments" element={<AssessmentsPage />} />
      <Route path="/mentors" element={<Mentors />} />
      <Route path="/mentors/:slug" element={<MentorProfile />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/order/:ref" element={<OrderStatus />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/become-a-mentor" element={<Navigate to="/contact?interest=mentor" replace />} />
      <Route path="/access" element={<AccessLogin />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/report/:id" element={<Report adminMode />} />
      <Route path="/admin/compare" element={<Compare />} />
      <Route path="/p/:slug" element={<PartnerPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/assessment" element={<Assessment />} />
      <Route path="/report/:id" element={<Report />} />
      <Route path="/shared/:shareId" element={<SharedReport />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
